var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04 4.54a.65.65 0 0 1 .92 0l5 5a.65.65 0 0 1 0 .92l-5 5a.65.65 0 1 1-.92-.92L11.58 10 7.04 5.46a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjA0MDM5IDQuNTQwMzhDNy4yOTQyMyA0LjI4NjU0IDcuNzA1NzggNC4yODY1NCA3Ljk1OTYzIDQuNTQwMzhMMTIuOTU5NiA5LjU0MDM4QzEzLjIxMzUgOS43OTQyMiAxMy4yMTM1IDEwLjIwNTggMTIuOTU5NiAxMC40NTk2TDcuOTU5NjMgMTUuNDU5NkM3LjcwNTc4IDE1LjcxMzUgNy4yOTQyMyAxNS43MTM1IDcuMDQwMzkgMTUuNDU5NkM2Ljc4NjU1IDE1LjIwNTggNi43ODY1NSAxNC43OTQyIDcuMDQwMzkgMTQuNTQwNEwxMS41ODA4IDEwTDcuMDQwMzkgNS40NTk2MkM2Ljc4NjU1IDUuMjA1NzggNi43ODY1NSA0Ljc5NDIyIDcuMDQwMzkgNC41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";